import { QueryCache, QueryClient } from '@tanstack/react-query';
import { logger } from '../utils/logger';
import { sendEvent } from './nativeBridge';

let isRefreshing = false;
// 토큰 갱신 후 재시도할 콜백들을 저장
let failedQueue: Array<() => void> = [];

// 토큰 갱신 후 대기중인 요청들을 처리
const processQueue = () => {
  failedQueue.forEach((callback) => callback());
  failedQueue = [];
};
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any, query) => {
      logger.error(
        `[Query Global Error] error message : ${error.message} \nAPI URL: /${query.queryKey[0]}`,
      );

      if (error.response?.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;

          // 토큰 재발급 요청
          sendEvent('UPDATE_TOKEN');
          window.addEventListener(
            'UPDATE_TOKEN_CALLBACK',
            () => {
              // isRefresh = false;
              queryClient.invalidateQueries({ queryKey: query.queryKey });
              processQueue();
            },
            { once: true },
          );
        }

        failedQueue.push(() => {
          queryClient.invalidateQueries({ queryKey: query.queryKey });
        });
      }
      // TODO: Global 에러 처리 로직 추가
    },
  }),
});

queryClient.setDefaultOptions({
  queries: {
    retry: 0,
    retryDelay: 1000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 1000 * 60 * 5,
  },
});
